import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Avatar, Icon } from 'antd';
import isURL from 'validator/lib/isURL';

import { openUrlInNewTab } from '../../../../../../../data/config/utils';
import { IconEdit, IconFacebookSquare, IconTwitterSquare, IconLinkedinSquare } from '../../../../../../../data/assets/icons';

import InlineItem from '../../../../../../../components/inlineitem';

class AgentProfileCard extends React.PureComponent {
    onClickEditAgent = () => {
        const { agent, onClickEdit } = this.props;
        onClickEdit(agent);
    };

    onClickFacebookIcon = () => {
        const { agent } = this.props;
        if (agent.socialLinks && agent.socialLinks.facebook && isURL(this.props.agent.socialLinks.facebook))
            openUrlInNewTab(this.props.agent.socialLinks.facebook);
    };

    onClickTwitterIcon = () => {
        const { agent } = this.props;
        if (agent.socialLinks && agent.socialLinks.twitter && isURL(this.props.agent.socialLinks.twitter))
            openUrlInNewTab(this.props.agent.socialLinks.twitter);
    };

    onClickLinkedinIcon = () => {
        const { agent } = this.props;
        if (agent.socialLinks && agent.socialLinks.linkedin && isURL(this.props.agent.socialLinks.linkedin))
            openUrlInNewTab(this.props.agent.socialLinks.linkedin);
    };

    render() {
        const { agent, onClickEdit } = this.props;
        return (
            <div className="ori-animated ori-fade-in ori-relative">
                {
                    onClickEdit &&
                    <div className="ori-absolute ori-align-right ori-align-top ori-pad-10 ori-font-light-hover-primary" onClick={this.onClickEditAgent}>
                        <IconEdit size={18} />
                    </div>
                }
                <div className="ori-flex-column ori-flex-ac ori-flex-jc">
                    <div className="ori-relative ori-b-mrgn-10">
                        <Avatar className="ori-border-white" size={80} icon="user" />
                        {
                            agent.isOnline &&
                            <div className="ori-absolute ori-bg-green ori-box-15 ori-border-radius-half ori-border-white ori-align-right-5 ori-align-top-6" />
                        }
                        <div className="ori-absolute ori-align-bottom ori-align-left ori-align-right ori-flex-row ori-flex-jc">
                            {
                                agent.role &&
                                <div className={classNames("ori-font-xs ori-bg-primary ori-font-white ori-lr-pad-10 ori-border-radius-20 ori-border-primary ori-capitalize", { "ori-bg-green ori-border-color-green": agent.role === 'admin', "ori-bg-danger ori-border-color-danger": agent.role === 'owner', })}>{agent.role}</div>
                            }
                        </div>
                    </div>
                    {
                        agent.firstName &&
                        <p className="ori-font-md ori-text-overflow-dotted ori-uppercase">{`${agent.firstName} ${agent.lastName}`}</p>
                    }
                    {
                        agent.pseudoName &&
                        <p className="ori-font-sm ori-font-light ori-capitalize ori-text-overflow-dotted">{`(${agent.pseudoName})`}</p>
                    }
                    {
                        agent.designation &&
                        <p className="ori-text-overflow-dotted ori-font-light">{agent.designation}</p>
                    }
                    {
                        agent.email &&
                        <p className="ori-text-overflow-dotted ori-font-light"><Icon type="mail" className="ori-r-mrgn-3" />{agent.email}</p>
                    }
                </div>
                {
                    agent.groups && agent.groups.length > 0 &&
                    <div className="ori-b-mrgn-10 ori-pad-10 ori-flex-row ori-flex-jc ori-flex-wrap">
                        {
                            agent.groups.map((group, index) => {
                                return (
                                    <div key={index} className="ori-lr-pad-10 ori-tb-pad-1 ori-mrgn-3 ori-bg-primary ori-border-primary ori-font-white ori-font-xs ori-border-radius-4 ori-capitalize">{group}</div>
                                );
                            })
                        }
                    </div>
                }
                {
                    agent.bio && agent.bio.trim().length > 0 &&
                    <div className="ori-text-center ori-pad-10">
                        <span className="ori-font-15 ori-line-height-1">&ldquo; {agent.bio} &rdquo;</span>
                    </div>
                }
                {
                    agent.socialLinks &&
                    <div className="">
                        <p className="ori-text-center ori-font-light ori-font-xs">You can follow me on</p>
                        <div className="ori-flex-row ori-flex-jc ori-flex-wrap">
                            <div className={classNames("ori-pad-5 ", { "ori-cursor-ptr ori-font-facebook": agent.socialLinks.facebook && isURL(agent.socialLinks.facebook) })} onClick={this.onClickFacebookIcon}><IconFacebookSquare size={24} /></div>
                            <div className={classNames("ori-pad-5", { "ori-cursor-ptr ori-font-twitter": agent.socialLinks.twitter && isURL(agent.socialLinks.twitter) })} onClick={this.onClickTwitterIcon}><IconTwitterSquare size={24} /></div>
                            <div className={classNames("ori-pad-5", { "ori-cursor-ptr ori-font-linkedin": agent.socialLinks.linkedin && isURL(agent.socialLinks.linkedin) })} onClick={this.onClickLinkedinIcon}><IconLinkedinSquare size={24} /></div>
                        </div>
                    </div>
                }
                <div className="ori-tb-mrgn-10 ori-bg-white ori-pad-10 ori-border-radius-4">
                    <p className="ori-text-overflow-dotted ori-uppercase ori-font-bold ori-b-mrgn-5">informations</p>
                    <div className="ori-lr-pad-10 ori-tb-pad-5 ori-bg-default">
                        <InlineItem title="status after login" info={agent.acceptingChatsAfterLogin} size="small" />
                        <InlineItem title="current status" info={agent.currentStatus} size="small" />
                        <InlineItem title="chat limit" info={`${agent.chatConcurrency} concurrent chat`} size="small" />
                    </div>
                </div>
            </div>
        );
    }
}

AgentProfileCard.propTypes = {
    agent: PropTypes.object,
    onClickEdit: PropTypes.func,
};

AgentProfileCard.defaultProps = {
    agent: {},
};

export default AgentProfileCard;



// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/members/agents/components/agentprofilecard/index.js